import React from 'react';
import { Popover } from '@headlessui/react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/outline';

interface Language {
  name: string;
  code: string;
}

interface LanguageDropdownProps {
  locale: string;
  languages: Language[];
  handleLanguageChange: (code: string) => void;
}

export default function LanguageDropdown({ locale, languages, handleLanguageChange }: LanguageDropdownProps) {
  return (
    <div className="print:hidden hidden md:ml-6 md:flex md:space-x-8">
      <Popover className="relative ml-auto nav-link border-transparent no-underline text-gray-500 hover:border-gray-300 hover:text-gray-700 print:hidden inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
        {({ open: popoverOpen, close: closePopover }) => (
          <>
            <Popover.Button className="flex items-center gap-x-1 font-medium uppercase">
              {locale}
              {popoverOpen ? (
                <ChevronUpIcon aria-hidden="true" className="h-5 w-5 flex-none transition-transform" />
              ) : (
                <ChevronDownIcon aria-hidden="true" className="h-5 w-5 flex-none transition-transform" />
              )}
            </Popover.Button>

            <Popover.Panel className="absolute left-0 right-0 z-[100] mt-3">
              {/* Backdrop overlay */}
              <div
                onClick={() => closePopover()}
                className="fixed w-full h-screen bg-transparent inset-0 left-0 top-0"
                aria-hidden="true"
              />

              {/* Language dropdown */}
              <div className="absolute right-0 w-56 overflow-hidden rounded-xl bg-white shadow-lg outline-1 outline-primary-10 z-10">
                {languages.map((item) => (
                  <button
                    type="button"
                    key={item.name}
                    onClick={() => handleLanguageChange(item.code)}
                    className={`flex w-full items-center gap-x-3 px-3 py-4 text-primary-10 cursor-pointer ${
                      item.code === locale ? 'bg-primary-2' : 'bg-white hover:bg-primary-1'
                    }`}
                  >
                    <span className="w-6 flex items-center justify-center">
                      {/* {item.code === locale && ( */}
                      {/*   <StyledIcon name="done" size="xl" className="text-primary-10" /> */}
                      {/* )} */}
                    </span>
                    <span>{item.name}</span>
                  </button>
                ))}
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
}
